import React, { useRef, useContext, useState, useEffect } from "react";
import MyResize from "../myResize";
import MyContext from "../../../context/MyContext";
import Draggable from "react-draggable";
import AuthContext from "../../../context/userAuth.context";
const TrackerShapes = ({
  StackStore,
  value,
  TickerPosition,
  zInd,
  resizeRef,
  resizeRef2,
  setMultiDrag,
  MultiDrag,
  Call_ScreenShot,
  setCall_ScreenShot,
}) => {
  const {
    CanvasDisplay,
    setLayersData,
    LayersData,
    EditorZoom,
    TickerStart,
    seteditableObject,
    IsPressedShiftKey,
  } = useContext(MyContext);
  const { authenticationData, Role } = useContext(AuthContext);
  const ShapesRef = useRef(null);
  const [Dragging, setDragging] = useState(false);
  const dragref = useRef(null);

  const locked = (e) => {
    e.target.previousSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const Unlock = async (obj) => {
    await StackStore();

    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === obj) {
        array[i].lock = false;
        array[i].layerlock = false;
        array[i].showDiv = true;
      }
    }
    setLayersData(array);
  };

  const LockShow = (e) => {
    e.target.nextSibling.style.display = "block";
    e.target.style.display = "none";
  };

  const TextClick = (key) => {
    const array = Array.from(LayersData);

    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        array[i].toolbar = true;
        array[i].Editable = true;
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
      }
    }
    setLayersData(array);
    seteditableObject({ showPanel: true, editableItem: value });
  };

  const Dragger = (e, data) => {
    if (data.node.nextSibling) {
      data.node.nextSibling.style.left = data.x + "px";
      data.node.nextSibling.style.top = data.y + "px";
      //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    }
  };

  const DragEnd = async (e, data) => {
    //data.node.style.transform = `translate(${data.x}px, ${data.y}px) rotate(${value.rotateAngle}deg)`
    const newArray = Array.from(LayersData);
    for (var i = 0; i < newArray.length; i++) {
      if (newArray[i].key === value.key) {
        newArray[i].x = (data.x / EditorZoom) * 100;
        newArray[i].y = (data.y / EditorZoom) * 100;
        newArray[i].originalX = (data.x / EditorZoom) * 100;
        newArray[i].originalY = (data.y / EditorZoom) * 100;
        newArray[i].Editable = true;
        newArray[i].toolbar = true;
        newArray[i].waitSS = true;
        newArray[i].showDiv = true;
      } else {
        newArray[i].Editable = false;
        newArray[i].toolbar = false;
        newArray[i].showDiv = false;

        if (newArray[i].type === "text") {
          newArray[i].edit = "false";
          if (newArray[i].FurtherSetting === true) {
            newArray[i].FurtherSetting = false;
          }
          if (newArray[i].Editable === true) {
            newArray[i].Editable = false;
          }
        }
      }
    }
    // if (!Call_ScreenShot) {
    //   setCall_ScreenShot(true);
    // }
    setLayersData(newArray);
  };

  const activeEdit = (params) => {
    if (!IsPressedShiftKey) {
      const newArray = Array.from(LayersData);
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].Editable = true;
          newArray[i].toolbar = true;
          newArray[i].showDiv = true;
        } else {
          newArray[i].Editable = false;
          newArray[i].toolbar = false;
          newArray[i].showDiv = false;
        }
      }
      setLayersData(newArray);
      //ShowPanelLeft
      seteditableObject({ showPanel: true, editableItem: value });
    }
  };

  const Activated = () => {
    if (MultiDrag.length > 1) {
      const arr = Array.from(MultiDrag);
      //setMultiDrag(arr);
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key == value.key) {
          if (value.InMultiDrag === false) {
            arr.push(array[i]);
            array[i].InMultiDrag = true;
          } else {
            const index = arr.indexOf(value);

            if (index > -1) {
              // only splice array when item is found
              arr.splice(index, 1); // 2nd parameter means remove one item only
            }
            value.InMultiDrag = false;
            var element = document.getElementsByClassName(
              "Inner-" + value.AnimationId
            );
            if (element.length > 0) {
              element.classList.remove("disableEvents");
            }
          }
        }
      }
      if (arr.length === 1) {
        setMultiDrag([]);
        const array = Array.from(LayersData);
        for (var i = 0; i < array.length; i++) {
          if (array[i].key === arr[0].key) {
            array[i].showDiv = true;
            array[i].Editable = true;
          }
        }
      } else {
        setMultiDrag(arr);
      }

      setLayersData(array);
    } else {
      let arr = [];
      const array = Array.from(LayersData);
      for (var i = 0; i < array.length; i++) {
        if (array[i].key !== value.key) {
          if (array[i].Editable == true) {
            arr.push(array[i]);
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        } else {
          arr.push(array[i]);
        }
      }
      if (arr.length > 1) {
        setMultiDrag(arr);
        for (const itr of array) {
          for (const atr of arr) {
            if (atr.key == itr.key) {
              itr.InMultiDrag = true;
            }
            atr.toolbar = false;
          }
        }
        setLayersData(array);
      } else {
        for (var i = 0; i < array.length; i++) {
          if (array[i].key == value.key) {
            array[i].toolbar = true;
            array[i].Editable = true;
          } else {
            array[i].Editable = false;
            array[i].showDiv = false;
          }
        }
        setLayersData(array);
        arr = [];
      }
    }
  };
  useEffect(() => {
    if (dragref.current) {
      dragref.current.style.transform = `translate(${
        (value.x * EditorZoom) / 100
      }px, ${(value.y * EditorZoom) / 100}px) rotate(${value.rotateAngle}deg)`;
    }
  }, [value.rotateAngle, dragref.current]);
  const generateClassWithShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag disableEvents checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder disableEvents checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };
  const generateClassWithoutShift = () => {
    if (Dragging) {
      if (value.InMultiDrag) {
        return "AniamteDrag checker";
      } else {
        return "AniamteDrag checker";
      }
    } else {
      if (value.InMultiDrag) {
        return "AniamteDrag dotedBorder checker";
      } else {
        return "AniamteDrag dotedBorder checker";
      }
    }
  };

  return (
    <>
      {value.opc === 1 && (
        <>
          {/* {!value.Editable && CanvasDisplay && (
                <MyResize Editable={value.Editable} resizeRef={ShapesRef} type={value.type} values={value} />
            )} */}
          {!value.Editable && CanvasDisplay && value.lock === false && (
            <Draggable
              defaultClassName={
                IsPressedShiftKey
                  ? generateClassWithoutShift()
                  : generateClassWithShift()
              }
              onMouseDown={(e) => {
                if (e.shiftKey) {
                  Activated();
                  return false;
                }
              }}
              onStart={(e) => {
                if (e.shiftKey) {
                  return false;
                } else {
                  setMultiDrag([]);
                  setDragging(true);
                  seteditableObject({ showPanel: true, editableItem: value });
                }
              }}
              onDrag={(event, data) => Dragger(event, data)}
              onStop={(event, data) => {
                DragEnd(event, data);
                setDragging(false);
              }}
              cancel={".resizable-handler , .square , .rotate"}
              position={{
                x: (value.x * EditorZoom) / 100,
                y: (value.y * EditorZoom) / 100,
              }}
            >
              <div
                ref={dragref}
                onClick={activeEdit}
                style={{
                  // display: (!CanvasDisplay ? 'none' :
                  //     TickerStart ? (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ?
                  //         'inline-block' : 'none' : (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' : 'none'),

                  display: !CanvasDisplay
                    ? value.player
                      ? "inline-block"
                      : "none"
                    : value.startPositionOnTimeline <= TickerPosition &&
                      value.startPositionOnTimeline + value.widthOnTimeline >=
                        TickerPosition
                    ? "inline-block"
                    : "none",

                  width: (value.width * EditorZoom) / 100,
                  height: (value.height * EditorZoom) / 100,
                }}
              ></div>
            </Draggable>
          )}

          <div
            className={
              "changer EditStart " +
              (value.Editable ? " RectBorder " : "") +
              (!CanvasDisplay ? value.InClass + value.OutClass : "")
            }
            style={{
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                ? "inline-block"
                : "none",
              border: value.lock == true ? "1px dashed #37484f" : "",
              height: (value.height * EditorZoom) / 100,
              width: (value.width * EditorZoom) / 100,
              VendorAnimationDuration: ".5s",
              zIndex: !value.lock ? zInd : 1500 + zInd,
              transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : "",
              left: Math.round((value.x * EditorZoom) / 100),
              top: Math.round((value.y * EditorZoom) / 100),
              cursor: value.lock == true ? "default" : "grab",
            }}
            onClick={() => {
              TextClick(value.key);
            }}
            ref={!value.Editable ? ShapesRef : resizeRef}
            id={"Outer-" + value.AnimationId}
          >
            {/* {value.Editable && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={ShapesRef} type={value.type} values={value} />
                )} */}
            {/* {!value.Editable && CanvasDisplay && (
                    <MyResize Editable={value.Editable} resizeRef={ShapesRef} type={value.type} values={value} />
                )} */}
            <span
              style={{
                display: value.InMultiDrag ? "none" : "block",
                width: "100%",
                height: "100%",
              }}
            >
              <img
                className={"ImgTag"}
                draggable={false}
                tabIndex="0"
                src={authenticationData.ApiBaseURL + "/" + value.ShapePath}
                style={{
                  transform: !CanvasDisplay
                    ? ` rotate(${value.rotateAngle}deg) ` + value.flip
                    : value.flip,
                  opacity: value.opacity,
                  position: "absolute",
                  top: "0",
                  left: "0",
                  zIndex: -1,
                }}
              />
            </span>
          </div>

          {value.showDiv && (
            <div
              id={"showDiv-" + value.AnimationId}
              ref={resizeRef2}
              style={{
                VendorAnimationDuration: ".5s",
                cursor: value.lock == true ? "default" : "grab",
                transform: CanvasDisplay
                  ? `rotate(${value.rotateAngle}deg)`
                  : "",
                display: !CanvasDisplay
                  ? value.player && !value.startAtoZ
                    ? "inline-block"
                    : "none"
                  : value.startPositionOnTimeline <= TickerPosition &&
                    value.startPositionOnTimeline + value.widthOnTimeline >=
                      TickerPosition
                  ? "inline-block"
                  : "none",
                height: (value.height * EditorZoom) / 100,
                width: (value.width * EditorZoom) / 100,
                zIndex: !value.lock ? 1000 : 1100 + 50,
                border:
                  value.lock == true ? "1px dashed red" : "2px solid #e87ed4",
                left: Math.round((value.x * EditorZoom) / 100),
                top: Math.round((value.y * EditorZoom) / 100),
                position: "absolute",
              }}
            ></div>
          )}
        </>
      )}

      {value.lock === true && value.opc === 1 && (<>
            <div className='RectBorder' style={{
                width: (value.width * EditorZoom) / 100, height: (value.height * EditorZoom) / 100, position: "absolute", zIndex: 1500,
                display: (!CanvasDisplay ? value.player ? 'inline-block' : 'none' : (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ? 'inline-block' : 'none'),
                left: Math.round((value.x * EditorZoom) / 100), top: Math.round((value.y * EditorZoom) / 100), transform: `rotate(${value.rotateAngle}deg)`,
            }}>
                <img className="ImgTag" draggable={false} tabIndex="0" src={value.ShapePath}
                    style={{ transform: value.flip, opacity: value.opacity, position: 'absolute', top: '0', left: '0' }}
                />
                <div data_set="lock_object" className="LockTop">
                    <div className="LockInnerBorder">
                        <span className="material-icons material-icons-outlined Lockback" tabIndex="0" onMouseOver={LockShow}>lock</span>
                        <span className="material-icons material-icons-outlined unlock " tabIndex="0" onMouseOut={locked} onClick={() => Unlock(value.key)}>lock_open</span>
                    </div>
                </div>
            </div>
        </>)}
    </>
  );
};

export default TrackerShapes;
